import { useEffect, useMemo, useRef, useState } from "react";
import { IconJsxer } from "../../helpers/IconHelper";
import "./ChatTranscript.scss";
import { toast } from "react-toastify";
import {CHANNEL_COLOURS } from "../../helpers/AnalyticsFunctions";
import DropDownList from "../../components/forms/DropDownList/DropDownList";
import { getStreamChannelId, getStreamChannelLabel, getStreamChannelProfilePic } from "../../helpers/StreamChannels";

const USER_NAME_COLOURS = [
    '#60A5FA',
    '#F472B6',
    '#34D399',
    '#F59E0B',
    '#A78BFA',
    '#2DD4BF',
    '#FB7185',
    '#F97316',
    '#38BDF8',
    '#E879F9',
    '#22C55E',
    '#F43F5E',
];

const normalizeUserKey = (name = '') => String(name || '').trim().toLowerCase();

const ChatTranscript = (props) => {
    const [chatOpen, setChatOpen] = useState(false);
    const toggleChat = (e) => {
        e.preventDefault();
        setChatOpen(!chatOpen);
    }

    const [lockToBottom, setLockToBottom] = useState(true);
    const scrollAreaRef = useRef(null);
    const scrollHandler = (e) => {
        if (scrollAreaRef.current) {
            // if (scrollAreaRef.current.scrollTop + 10 < scrollAreaRef.current.scrollHeight - scrollAreaRef.current.offsetHeight) {
            if (scrollAreaRef.current.scrollHeight - scrollAreaRef.current.scrollTop - scrollAreaRef.current.clientHeight < 1) {
                setLockToBottom(true);
            } else {
                setLockToBottom(false);
            }
        }
    }
    const copyAMA = (amaQuestion) => {
        let lowerCaseQuestion = amaQuestion.toLowerCase();
        let index = lowerCaseQuestion.match(/ask/).index +3;
        let copiedAMA = amaQuestion.substring(index);
        if(copiedAMA[0] == ' ') copiedAMA = copiedAMA.substring(1);
        navigator.clipboard.writeText(copiedAMA);
        toast.success("Question copied to clipboard: "+copiedAMA);

    }
    const [channelList, setChannelList] = useState([])
    useEffect(
        () => {
            if (lockToBottom) {
                if (scrollAreaRef.current) {
                    scrollAreaRef.current.scrollTo(0, scrollAreaRef.current.scrollHeight);
                }
            }

    

        }
    )

    useEffect( () =>{
        if(props.channels)
            {
                let sortedChannels = props.channels.toSorted(function(a, b) {
                    var textA = getStreamChannelLabel(a).toUpperCase();
                    var textB = getStreamChannelLabel(b).toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
                console.log('SORT COLOURS')
                setChannelList(sortedChannels)
            }
    }, [props.channels])

    const availableChannels = useMemo(() => {
        const channelIds = [];
        const seenChannels = new Set();

        (props.chatHistory || []).forEach((entry) => {
            if (!entry?.channel || seenChannels.has(entry.channel)) {
                return;
            }

            seenChannels.add(entry.channel);
            channelIds.push(entry.channel);
        });

        return channelIds;
    }, [props.chatHistory]);

    const userNameColours = useMemo(() => {
        const colourMap = new Map();
        let nextColourIndex = 0;

        (props.chatHistory || []).forEach((entry) => {
            const userKey = normalizeUserKey(entry?.name);
            if (!userKey || colourMap.has(userKey)) {
                return;
            }

            colourMap.set(userKey, USER_NAME_COLOURS[nextColourIndex % USER_NAME_COLOURS.length]);
            nextColourIndex += 1;
        });

        return colourMap;
    }, [props.chatHistory]);

    const getChannelColour = (channel) => {

        for(let i=0; i<channelList.length; i++)
        {
            if(getStreamChannelId(channelList[i]) == channel.toLowerCase() ) return CHANNEL_COLOURS[i%8];
        }
    }
    const getProfilePic = (channel) => {

        for(let i=0; i<channelList.length; i++)
        {
            if(getStreamChannelId(channelList[i]) == channel.toLowerCase() ) return getStreamChannelProfilePic(channelList[i]);
        }

        return getStreamChannelProfilePic(channel);
    }

    const getChannelLabel = (channel) => {
        for(let i=0; i<channelList.length; i++)
        {
            if(getStreamChannelId(channelList[i]) == channel.toLowerCase() ) return getStreamChannelLabel(channelList[i]);
        }

        return getStreamChannelLabel(channel);
    }

    const getUserNameColour = (name) => {
        return userNameColours.get(normalizeUserKey(name)) || USER_NAME_COLOURS[0];
    }

    const updateChannelFilterHandler = async (e, id, item) => {

        console.log(item, id)
        console.log('SET', item)
        setChannelFilter(item);
    }
    const [channelFilter, setChannelFilter] = useState(null);
    const GetSessionDropdown = () => {
    
        let dropDownItems = 
            [
                {id:'all', label:'All'}
            ];
    
        if(availableChannels &&  availableChannels.length >= 1)
        {
            for(let i=0; i<availableChannels.length; i++)
            {
                let channelObj = availableChannels[i];
                dropDownItems.push({id:channelObj, label:getChannelLabel(channelObj) })
            }
        }
    
        return(
            <DropDownList 
            id="assignedTo" 
            selectFunc={updateChannelFilterHandler}
            currentIndex={channelFilter ? channelFilter.index : 0}
            icon="oneUser"
            items={
                dropDownItems
            }
            className="filter"
        >
    
        </DropDownList>
        )
    
    
    }

        

    return (
        <>
            <div className={`chat-transcript${chatOpen ? ' ct-open' : ''}`}>
                <div className="chatHistory fl-row">
                <h4>Chat History</h4>
                {GetSessionDropdown(props)}
                </div>
                <div className="titles chat fl-row">
                <p className='channel-title'>Channel:</p>
                <p> Chat Message</p>
                 </div>
                <div className="scroll-area" ref={scrollAreaRef} onScroll={scrollHandler}>
                {props.chatHistory.map(
                    (val, i) => {
                        if(!channelFilter || channelFilter.id == val.channel || channelFilter.id == 'all' )
                        {
                        const message = val.hashtag ? val.message.replace(val.hashtag, `<span class="hash-hilight">${val.hashtag}</span>`) : val.message;
                        return (
                            <>

                            <div className="chat fl-row">
                            <div className='channel' title={getChannelLabel(val.channel)} style={{border:"2px solid "+getChannelColour(val.channel)}}>
                                <img className='channel-avatar' src={getProfilePic(val.channel)} alt={getChannelLabel(val.channel)} />
                            </div>
                            {val.isAMA && 
                                  <div className="chat-message-block" onClick={() => {copyAMA(val.message)}} key={'chat_' + i}>
                                      <div className="name" style={{color: getUserNameColour(val.name)}}>{val.name}:</div>
                                      <div className='ama' dangerouslySetInnerHTML={{__html: message}}></div>
                                  </div>
                            }
                                 {!val.isAMA && 
                                 <div className="chat-message-block" key={'chat_' + i}>
                                    <div className="name" style={{color: getUserNameColour(val.name)}}>{val.name}:</div>
                                    <p className="chat-message-text"><span dangerouslySetInnerHTML={{__html: message}}></span></p>
                                </div>
                            }
                            </div>
                            </>
                            
                                    )
                        
                            }
                    }
                    )
                }
                </div>
            </div>

            <div className="chat-toggle-button" onClick={toggleChat}>
                {IconJsxer.GetIcon(IconJsxer.ICONS.chatHistory, IconJsxer.ICON_STYLES.chatToggleControlButton)}
            </div>
            </>
       
        
    )
}

export default ChatTranscript;
